<template>
    <div class="nav-content">
        <div class="feedback-box" :class="{mobile: this.$utils.isMobile()}">
            <div class="oands">
                <div v-if="subed === false">
                    <div class="input-box" :class="{mobile: this.$utils.isMobile()}">
                        <input type="text" maxlength="50" class="contact" v-model="contact" placeholder="您的联系方式(可选)" autofocus="autofocus">
                        <textarea maxlength="1000" placeholder="推荐网站或在使用中碰到问题？" v-model="content" :class="{mobile: this.$utils.isMobile()}"></textarea>
                    </div>
                    <div class="oands-hint">
                        <span>或发送邮件到: <a href="mailto:k@anyknew.com?subject=反馈">k@anyknew.com</a></span>
                    </div>
                    <div class="save-box">
                        <div>
                            <button class="save-btn" @click="do_submit">提 交</button>
                        </div>
                    </div>
                </div>
                <div class="subed-box" :class="{mobile: this.$utils.isMobile()}" v-else>
                    <span>已提交</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
  export default {
    name: 'feedback',
    data: function () {
      return {
        contact: '',
        content: '',
        subed: false
      }
    },
    created: function () {
    },
    methods:{
      do_submit: function () {
        if(this.content.length < 10){
          this.$utils.transitMsg('有点太少了，起码凑10个字吧', 2000)
          return
        }
        var that = this
        this.$http.post('/feedback', {contact: this.contact, content: this.content}, function (r) {
          if (r.status === 0) {
            that.subed = true
            that.contact = ''
            that.content = ''
          } else {
            that.$utils.transitMsg(r.msg, 2000)
          }
        })
      }

    }
  }
</script>

<style lang="less">
    .feedback-box{
        margin: auto;
        margin-top: 50px;
        width: 50%;
        border-radius: 5px;
        background-color: #FFFFFF;
        &.mobile{
            width: 90%;
            margin-top: 35px;
        }
        .oands{
            .subed-box{
                width: 100%;
                height: 260px;
                padding: 20px;
                display: flex;
                font-size: 1.1rem;
                justify-content: center;
                align-items: center;
                &.mobile{
                    height: 260px;
                }
            }
            .input-box{
                width: 100%;
                height: 260px;
                padding: 20px;
                border-radius: 10px;
                position: relative;
                .contact{
                    border: 0;
                    border-bottom: 1px solid #E2E2E2;
                    /*height: 30px;*/
                    /*line-height: 30px;*/
                    padding-bottom: 10px;
                    font-size: 1.1rem;
                }
                textarea {
                    padding: 10px 0;
                    width: 100%;
                    height: 200px;
                    border: 0;
                    font-size: 1.1rem;
                    resize: none;
                    border-bottom: 1px solid #E2E2E2;
                    &.mobile{
                        height: 290px;
                    }
                }
                &.mobile{
                    height: 350px;
                }
            }
            .oands-hint{
                padding: 5px 20px;
                font-size: 0.9rem;
                color: #999999;
                a{
                    color: #999999;
                }
            }
            .save-box{
                display: flex;
                justify-content: center;
                align-items: center;
                .holder{
                    flex: 1;
                }
                .save-btn{
                    margin: 20px;
                    background-color: #3DB4F1;
                    color: #FFFFFF;
                    padding: 10px 20px;
                    font-size: 1.2rem;
                    border: 0;
                    text-align: center;
                    border-radius: 5px;
                }
            }

        }
    }

</style>
